import { render, staticRenderFns } from "./DadosTurma.vue?vue&type=template&id=4754bb68&"
import script from "./DadosTurma.vue?vue&type=script&lang=js&"
export * from "./DadosTurma.vue?vue&type=script&lang=js&"
import style0 from "./DadosTurma.vue?vue&type=style&index=0&id=4754bb68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports